module.exports = __webpack_public_path__ + "img/icons_top__Network.2d1c1c49.png";